import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
    CO_SIGNATURE_REVIEW_REQUEST,
    CO_SIGNATURE_REVIEW_SUCCESS,
    CO_SIGNATURE_REVIEW_FAILURE,
    CO_SIGNATURE_REVIEW_RESET,
    CO_SIGNATURE_REVIEW_LOADING,
} = DashboardConstants;

function* coSignatureReview(action: any): SagaReturnType<any> {
  try {
    yield put({ type: CO_SIGNATURE_REVIEW_LOADING });
    const response = yield call(dashboardServices.updateCoSignatureStatus, action.payload);
    if (response?.status === 200) {
      yield put({
        type: CO_SIGNATURE_REVIEW_SUCCESS,
        payload: response.data,
        requestType: action.payload?.superviseStatus,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CO_SIGNATURE_REVIEW_FAILURE, payload: error });
  }
}

function* coSignatureReviewSaga() {
  yield takeEvery(CO_SIGNATURE_REVIEW_REQUEST, coSignatureReview);
}

export default coSignatureReviewSaga;
